import ProxyBase from '../../../../../../core/proxies/ProxyBase'

class HighLightProxy extends ProxyBase {
  getRiskScaleInterpretation(params) {
    return this.get('Score/RiskScore/RiskScaleInterpretation', params)
  }

  getIndustryMedianRiskScore(params) {
    return this.get('IndustryAnalysis/GetIndustryMedianRiskScore', params)
  }

  financialRatioHighlight(params) {
    return this.get('IndustryAnalysis/FinancialRatioHighlight', params)
  }
}

export default new HighLightProxy('')
